/**
 * IMPORTS
 */

import * as Sentry from "@sentry/react";

import { formatAuditTimestamp } from "@/utils/formatted-datetime";

// env

// typings

type ISolicitacaoRemessaAudit = {
  user: any;
  payload: any;
  response?: any | unknown;
  error?: unknown;
};

/**
 * Auditoria de Solicitação de Remessa no Sentry
 */
async function handleSentryLogSolicitacaoRemessa({
  user,
  payload,
  response,
  error,
}: ISolicitacaoRemessaAudit) {
  try {
    await Sentry.startSpan(
      {
        name: "SolicitacaoRemessa",
        op: "audit",
      },
      async (span) => {
        try {
          const now = new Date().toISOString();

          Sentry.withScope((scope) => {
            // 🏷️ Tags
            scope.setTag("tipo_evento", "solicitacao_remessa");
            scope.setTag("user_id_solicitante", String(payload.user_id_solicitante_remessa));
            scope.setTag("versao_app", "1.0.0");

            // 👤 Usuário
            scope.setUser({
              id: String(user?.id ?? payload.user_id_solicitante_remessa),
              email: user?.email,
              username: user?.nome ?? "Usuário",
            });

            // 📦 Extras (auditoria)
            scope.setExtra("auditoria_solicitacao_remessa", {
              horario_envio: now,
              payload_enviado: payload,
              response_api: response,
              erro_api: error,
            });

            // 📝 Mensagem auditável
            Sentry.captureMessage(
              `ℹ️ Auditoria da solicitação de remessa realizada pelo usuário ID: ${payload.user_id_solicitante_remessa} em ${formatAuditTimestamp(new Date())}`,
              {
                level: "info",
                fingerprint: ["solicitar-remessa", String(Date.now().toLocaleString())],
              }
            );
          });

          // 🔄 Garante envio em fluxo crítico
          await Sentry.flush(2000);
        } catch (error) {
          span?.setStatus({
            code: 2,
            message: "error",
          });
          Sentry.captureException(error);
        }
      }
    );
  } catch (error) {
    // 🛡️ Nunca interrompe o fluxo principal
    console.warn("⚠️ Falha ao registrar auditoria de solicitação de remessa no Sentry:", error);
  }
}

/**
 * EXPORTS
 */
export { handleSentryLogSolicitacaoRemessa };
